import { WorkflowStage } from "@/constants/workflowStages"

/**
 * Stages where a vendor sees the comment input. At other stages (e.g. INACTIVE) a vendor can still
 * read but gets no comment or proposal inputs.
 */
const VENDOR_COLLABORATION_STAGES: ReadonlySet<string> = new Set([
  WorkflowStage.Review,
  WorkflowStage.Approved,
  WorkflowStage.Active,
])

/**
 * Whether a vendor may comment at this stage. False for DRAFT and INACTIVE, where reads stay open.
 */
export function canVendorCollaborate(stage: string | undefined | null): boolean {
  return stage != null && VENDOR_COLLABORATION_STAGES.has(stage)
}

/**
 * Whether a proposal may be created or reviewed: only in REVIEW, mirroring the Cedar `ProposeOnDTA`
 * rule and the backend review check.
 */
export function canProposeAtStage(stage: string | undefined | null): boolean {
  return stage === WorkflowStage.Review
}

/**
 * Format an ISO date string, e.g. "Jan 5, 2025, 3:42 PM".
 */
export function formatDateTime(dateString: string): string {
  return new Date(dateString).toLocaleString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
  })
}
